import { ProductPackage } from './ProductPackage'

export class ProductGroup {
  constructor ({ name, code, id, description, packages }) {
    this.name = name
    this.code = code
    this.id = id
    this.description = description
    this.packages = []
    packages.forEach(productPackage => {
      this.packages.push(new ProductPackage({ ...productPackage, groupCode: this.code }))
    })
  }
}
